import {Component} from '@angular/core';
import { GoogleAuthenticationService } from 'src/app/core/services/login/google-authentication.service';
import { WindowService } from 'src/app/core/services/window/window.service';

import { ChangeBpComponent } from './change-bp/change-bp.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { ChangePasswordComponent } from 'src/app/pages/external/external-home/change-password/change-password.component';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent {

  /** Set when the Google profile photo fails to load, so we fall back to the placeholder avatar. */
  photoFailed = false;

  constructor(
    private googleAuthenticationService: GoogleAuthenticationService,
    private authorizationService: AuthorizationService,
    private windowService: WindowService,
    private crewInfoStore: CrewInfoStore,
    public dialog: MatDialog) {
  }

  get photo(): string {
    return this.googleAuthenticationService.getGoogleUser()?.photo || '';
  }

  get hasPhoto(): boolean {
    return !!this.photo && !this.photoFailed;
  }

  onPhotoError(): void {
    this.photoFailed = true;
  }

  get name(): string {
    return this.crewInfoStore.crewInfo()?.firstName || '';
  }

  get isAdmin(): boolean {
    return this.authorizationService.isAdmin();
  }

  get isExternal(): boolean {
    return this.authorizationService.isExternal();
  }

  openDialogChangeBp(): void {
    this.dialog.open(ChangeBpComponent, {
      width: '520px',
      maxWidth: 'calc(100vw - 24px)',
      panelClass: 'change-bp-panel'
    });
  }

  openDialogEditExternalCrew(): void {
    const crewInfo = this.crewInfoStore.crewInfo();

    this.dialog.open(ChangePasswordComponent, { 
      width: '775px', 
      autoFocus: false, 
      data: {
        crew: crewInfo,
        mode: 'details'
      }
    });
  }

  logout() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '420px',
      maxWidth: 'calc(100vw - 24px)',
      data: {
        title: `Até mais, ${this.name}`,
        html: '<p>Tem certeza que deseja encerrar sua sessão?</p>',
        confirmButtonText: 'Sair'
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.windowService.toOrigin();
        sessionStorage.clear();
      }
    });
  }

}
